export const tutorialSteps = {
  WELCOME: 1,
  DASHBOARD_PRO: 2,
  CREATE_INTERVIEW: 3,
  CLICK_AUTOFILL: 4,
  FILL_JD: 5,
  CLICK_AUTO_FILL_BUTTON: 6,
  JOB_ROLE: 7,
  TECH_STACK: 8,
  SKILLS_SELECT: 9,
  EXPERIENCE_YEARS: 10,
  ADD_EXAM: 11,
  INPUT_FILE: 12,
  UPLOAD_FILE: 13,
  COST_CARD: 14,
  MAIL_TEMPLATE: 15,
  MAIL_TEMPLATE2: 16,
  MAIL_TEMPLATE3: 17,
  MAIL_TEMPLATE4: 18,
  SUBMIT_BUTTON: 19,
};